export default __webpack_public_path__ + "static/media/h-w-2.d6c15446.svg";